import { graphql } from 'graphql-schema';

export default graphql(`
  query currentUser {
    currentUser {
      _id
      roles {
        _id
        role
      }
      email
      firstName: first_name
      lastName: last_name
      picture: profile_picture
      home_organization
      gender
      privacy_preferences {
        _id
        share_email
        share_phone
      }
      organization_admins(
        # NOTE:
        # Filtering for discoverable organizations here since as of 07/2025 migration release,
        # non-discoverable organizations are filtered out by hasura by default. Might want to look
        # at lifting this restriction for admin/owner specifically in the admin app.
        where: { organizationByOrganization: { is_discoverable: { _eq: true } } }
        order_by: { organizationByOrganization: { name: asc } }
      ) {
        _id
        organization
        organizationByOrganization {
          _id
          name
        }
      }
    }
    organizations(order_by: { name: asc }) {
      _id
      name
    }
  }
`);
